import React, { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Badge, Menu, Tooltip, Button } from 'antd';
import Cookie from 'js-cookie';
import { ArrowLeftOutlined, BellOutlined } from '@ant-design/icons';
import UserInfo from "./UserInfo";
import { getUserImg, judgeIsLogin } from '../../common/utils';
import Logo from "../assets/images/qingcloud_new.svg";

interface IProps extends RouteComponentProps {
  userinfo: any;
};
interface IState {
  currMent: string,
  notifications: any[]
}
type menu = {
  key: string,
  name: string,
  path: string
}

const mainMenu: menu[] = [
  {
    key: 'home',
    name: '首页',
    path: '/'
  },
  {
    key: 'course',
    name: '课程中心',
    path: '/college/menu/main/course'
  },
  {
    key: 'exam',
    name: '考试中心',
    path: '/college/menu/main/exam'
  },
  {
    key: ' knowledge',
    name: '知识库',
    path: '/college/menu/main/knowledge'
  },
  // {
  //   key: 'train',
  //   name: '活动中心',
  //   path: '/college/menu/main/activity'
  // },
  // {
  //   key: 'project',
  //   name: '项目挑战',
  //   path: '/college/menu/main/project'
  // },
  // {
  //   key: 'topic',
  //   name: '话题小组',
  //   path: '/college/menu/main/topic'
  // },
]

class MenuComp extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      currMent: '',
      notifications: [
        { title: '第一条消息' }
      ]
    }
  }
  componentDidMount() {
    this.computedUrl(this.props.location.pathname);
  }
  componentDidUpdate(prevState: any, prevProps: any) {
    if (prevProps.currMent !== this.props.location.pathname) {
      this.computedUrl(this.props.location.pathname);
    }
  }
  // 匹配菜单
  computedUrl = (url: string) => {
    let _url = "";
    mainMenu.map(item => {
      if (url.indexOf(item.path) === 0) { // 存在
        _url = item.path;
      }
      return item;
    })
    this.setState({
      currMent: _url
    })
  }
  // 切换菜单
  handleClick = (e: any) => {
    console.log("切换");
    // if (judgeIsLogin()) {
    this.props.history.push(e.key);
    // }
  }
  // 去首页
  goHome = () => {
    this.props.history.push('/');
  }
  // 登陆
  goLogin = () => {
    // Cookie.set("mm", 123456);
    // Cookie.remove("mm");
    judgeIsLogin();
    // window.location.href = redirectUrl;
  }
  // // 卸载
  // componentWillUnmount() {
  //   localStorage.removeItem('collegeMenu');
  // }

  render() {
    const { currMent } = this.state;
    const { userinfo } = this.props;
    const _info = getUserImg(userinfo.crm_account_name);
    return (
      <div className="college_nav">
        <div className="nav">
          <div className="logo" onClick={this.goHome}>
            <img src={Logo} alt="" />
            <span className="line">|</span>
            <span className="text">合作伙伴支持平台</span>
            <a className='workSpaceLink' onClick={(e)=>e.stopPropagation()} href="https://partner.quanxiangyun.com/qingcloud">
              <ArrowLeftOutlined />
                工作台
            </a>
          </div>
          <div className="menu">
            <Menu onClick={this.handleClick} selectedKeys={[currMent]} mode="horizontal">
              {
                mainMenu.map(item => {
                  return (
                    <Menu.Item key={item.path}>{item.name}</Menu.Item>
                  )
                })
              }
            </Menu>
          </div>
          <div className="user">
            {/* <Popover trigger="click" placement="bottomRight"
              content={
                <div style={{width: 200}}>
                  <List
                    itemLayout="horizontal"
                    dataSource={notifications}
                    locale={{
                      emptyText: <div>您也查看所有通知.</div>,
                    }}
                    renderItem={item => (
                      <List.Item >
                        <List.Item.Meta title={item.title} />
                        <Button type='link'>查看</Button>
                      </List.Item>
                    )}
                  />
                {notifications.length ? (
                  <Button type='link' style={{color: 'red'}}>清空消息</Button>
                ) : null}
                </div>
              }
            > */}
            {/* <Badge dot>
                <BellOutlined />
              </Badge> */}
            {/* </Popover> */}
            <div className="kong"></div>
            <div className="usermsg">
              {/* <Popover className="userinfos" content={<UserInfo />} placement="bottom">
              <img src={User} alt=""/>
            </Popover> */}
              {/* <div className="img" style={{background: `${_info.color}`}}>{_info.name}</div>
              <div className="userinfo">
                <UserInfo />
              </div> */}
              {
                userinfo.id ?
                  <Tooltip autoAdjustOverflow={true} overlayClassName="usertip" placement={"bottomRight"} title={<UserInfo />} color='#FFF' >
                    <div className="img" style={{ background: `${_info.color}` }}>{_info.name}</div>
                  </Tooltip>
                  : <div style={{ color: "#1DA57A", cursor: "pointer" }} onClick={this.goLogin}>登录</div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default withRouter(MenuComp);
